module.exports = __webpack_public_path__ + "resources/img/ic-hk.ef4af535.png";